import { TBoxStructure } from 'components/EMManagement/EMManagementId/EasParamsBox/types';
import { TEmManagementByIdFullResponse } from 'redux/reducers/emManagement/types';
import { ETableStructureType } from 'ui/EasTable/types';
import { EEmEnums } from 'redux/reducers/emManagement/constants';

export const easFeeConfigurationBoxStructure: TBoxStructure<TEmManagementByIdFullResponse> = {
	header: [],
	body: [
		// fee_class
		{
			name: 'Fee Class Mode',
			selector: 'feeClass',
			type: ETableStructureType.ARRAY_ID,
			enumName: EEmEnums.FEES_CLASS,
			editable: false,
			show: true,
		},
		// 1 fee_class_id
		{
			name: 'Transactional Fee Class',
			selector: 'feeClassId',
			type: ETableStructureType.ARRAY_ID,
			enumName: EEmEnums.MANUAL_FEE_CLASS,
			editable: true,
			show: true,
		},
		// fee_class_automatic_applicable
		// {
		// 	name: 'Applicable Auto Fee Class',
		// 	selector: 'feeClassAutomaticApplicable',
		// 	type: ETableStructureType.BOOLEAN,
		// 	editable: false,
		// 	show: true,
		// },
		// post_sale_fee_class_id (hidden)
		{
			name: 'Post Sale Orders Fee Class',
			selector: 'postSaleFeeClassId',
			type: ETableStructureType.ARRAY_ID,
			enumName: EEmEnums.MANUAL_FEE_CLASS,
			editable: false,
			show: true,
		},
		// reporting_fee_type_id
		{
			name: 'Monthly Subscription Plan',
			selector: 'reportingFeeTypeId',
			type: ETableStructureType.ARRAY_ID,
			enumName: EEmEnums.MONTHLY_FEES,
			enumNameForEditing: EEmEnums.EM_REPORTING_FEE_ACTUAL,
			editable: true,
			show: true,
		},
		// annual_fee_type_id
		{
			name: 'Non Union Subscription Plan',
			selector: 'annualFeeTypeId',
			type: ETableStructureType.ARRAY_ID,
			enumName: EEmEnums.ANNUAL_FEE_TYPE_ID,
			editable: true,
			show: true,
		},
		// invoice_fee_type_id
		{
			name: 'Invoicing Fee',
			selector: 'invoiceFeeTypeId',
			type: ETableStructureType.ARRAY_ID,
			enumName: EEmEnums.INVOICE_FEE_TYPE_ID,

			editable: true,
			show: true,
		},
		// customs_data_fixed_fee
		{
			name: 'Customs data fee',
			selector: 'customsDataFixedFee',
			type: ETableStructureType.AMOUNT,
			editable: true,
			show: true,
		},
		// customs_data_percentage_fee
		{
			name: 'Customs Data Fee, %',
			selector: 'customsDataPercentageFee',
			type: ETableStructureType.NUMBER,
			editable: true,
			show: true,
		},
		// charged_by_shopify
		{
			name: 'Charged by Shopify ($5.90)',
			selector: 'chargedByShopify',
			type: ETableStructureType.BOOLEAN,
			editable: true,
			show: true,
		},
	],
	title: 'EAS Fee Configuration',
	onBeforeSave: (values) => {
		const updated = { ...values };
		// Keep postSaleFeeClassId in sync with feeClassId when changed
		if (Object.prototype.hasOwnProperty.call(updated, 'feeClassId')) {
			updated.postSaleFeeClassId = updated.feeClassId;
		}
		// If reportingFeeTypeId cleared, leave feeClassId/postSaleFeeClassId unchanged
		return updated;
	},
	banner: {
		message: 'You can only update one field at a time. Please update one field at a time.',
		type: 'warning',
	},
};
